import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('master-list/index', {params});
    },
    getDetail(params) {
        return Service().get('master-list/get-detail-master-list', {params});
    },
    show(id) {
        return Service().get('master-list/show/'+id);
    },
    create(params) {
        return Service().post('master-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('master-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('master-list/delete/'+id);
    },
}